import React, { Component }     from "react";
import { Button, MenuItem, Modal, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon }          from '@fortawesome/react-fontawesome'
import LoaderButton                 from "../../components/LoaderButton";
import { Colors }                   from "../../utils/Colors";
import { invokeGetAssessmentDetail} from "../../utils/AwsInvoke";
import { XYPlot,
          Crosshair,
          DiscreteColorLegend,
          FlexibleWidthXYPlot,
          HorizontalGridLines,
          LineSeries,
          LineMarkSeries,
          VerticalGridLines,
          SearchableDiscreteColorLegend,
          XAxis,
          YAxis }        from 'react-vis';
//import { invokeGetClientAssessmentSpecificReport } from "../../utils/AwsInvoke";

const axisProps = {
    tickSizeInner: 0,
    style: {line: {stroke: '#939393', strokeWidth: '1px'}}
};

const restingHeartRate_color            = "#c22a2a";
const systolicBloodPressure_color       = "#6621c4";
const diastolicBloodPressure_color      = "#2e78e7";
const heartRateVariabilityScore_color   = "#56e7fc";
const hdl_color                         = "#fc9856";
const ldl_color                         = "#fc56a0"
const totalCholesterol_color            = "#c91bde";
const totalCholesterolRatio_color       = "#3da211";

const STRENGTH_LEGEND = [
    {title: 'All',  data: "all_data", color: "#000", strokeWidth: 14},
    {title: 'Resting Heart Rate',  data: "restingHeartRate_data", color: restingHeartRate_color, strokeWidth: 14},
    {title: 'Systolic Blood Pressure', data: "systolicBloodPressure_data", color: systolicBloodPressure_color, strokeWidth: 14 },
    {title: 'Diastolic Blood Pressure', data: "diastolicBloodPressure_data", color: diastolicBloodPressure_color, strokeWidth: 14 },

    {title: 'Heart Rate Variability Score', data: "heartRateVariabilityScore_data", color: heartRateVariabilityScore_color, strokeWidth: 14 },
    {title: 'HDL', data: "hdl_data", color: hdl_color, strokeWidth: 14 },
    {title: 'LDL', data: "ldl_data", color: ldl_color, strokeWidth: 14 },
    {title: 'Total Cholesterol', data: "totalCholesterol_data", color: totalCholesterol_color, strokeWidth: 14 },
    {title: 'Total Cholesterol Ratio', data: "totalCholesterolRatio_data", color: totalCholesterolRatio_color, strokeWidth: 14 },
];

var restingHeartRate_data           = [];
var systolicBloodPressure_data      = [];
var diastolicBloodPressure_data     = [];
var heartRateVariabilityScore_data  = [];
var hdl_data                        = [];
var ldl_data                        = [];
var totalCholesterol_data           = [];
var totalCholesterolRatio_data      = [];

var legend1_title = "Resting Heart Rate";
var legend2_title = "Systolic Blood Pressure";
var legend3_title = "Diastolic Blood Pressure";
var legend5_title = "Heart Rate Variability Score";
var legend6_title = "HDL";
var legend7_title = "LDL";
var legend8_title = "Total Cholesterol";
var legend9_title = "Total Cholesterol Ratio";

export default class AssessHeartAndBlood extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            title:     "Heart & Blood Assessment",
            max_y_val: 0,
            min_y_val: 0,
            all_data: true,
            yAxisLabel: "",
            crosshairPreValues:      [],
        }
    }

    componentDidMount() {

        try {
            this.getClientData();
        } catch (e) {
            alert(e);
        }
    }

    resetDataVals () {
        restingHeartRate_data           = [];
        systolicBloodPressure_data      = [];
        diastolicBloodPressure_data     = [];
        heartRateVariabilityScore_data  = [];
        hdl_data                        = [];
        ldl_data                        = [];
        totalCholesterol_data           = [];
        totalCholesterolRatio_data      = [];
    }

    getClientData = async () => {
        this.setState({
            loadingData: "Loading member data ... "
        })

        const results  = this.props.resultsHeartAndBlood;

        var asessInbodyChartData = [];
        var max_yaxis_val        = [];

        // Reset all vals in case someone clicks "All" multiple times; we don't want multiple duplicate vals
        this.resetDataVals();

        if(results) {
            var data            = results.data.heartandblood;
            var ctr = 0;
            var max_array = [];
            ////  BEGIN: BUILD OUT GRAPH DATA  ////
            for(var key in data) {
                var restingHeartRate            = data[key].restingheartrate;
                var systolicBloodPressure       = data[key].systolicbloodpressure
                var diastolicBloodPressure      = data[key].diastolicbloodpressure;
                var heartRateVariabilityScore   = data[key].heartratevariabilityscore
                var hdl                         = data[key].hdl
                var ldl                         = data[key].ldl;
                var totalCholesterol            = data[key].totalcholesterol;
                var totalCholesterolRatio       = data[key].totalcholesterolratio;
                var date_created        = data[key].date_created;
                var date                = (new Date(date_created)).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })

                restingHeartRate_data.push({"x": date, "y": restingHeartRate});
                systolicBloodPressure_data.push({"x": date, "y": systolicBloodPressure});
                diastolicBloodPressure_data.push({"x": date, "y": diastolicBloodPressure});
                heartRateVariabilityScore_data.push({"x": date, "y": heartRateVariabilityScore});
                hdl_data.push({"x": date, "y": hdl});
                ldl_data.push({"x": date, "y": ldl});
                totalCholesterol_data.push({"x": date, "y": totalCholesterol});
                totalCholesterolRatio_data.push({"x": date, "y": totalCholesterolRatio});

                // Get Max Value of All Data points and then filter out the highest value to use in the y-axis //
                max_array.push(restingHeartRate, systolicBloodPressure, diastolicBloodPressure, heartRateVariabilityScore, hdl, ldl, totalCholesterol, totalCholesterolRatio)
            }

            var max_y_val = Math.max(...max_array) + 35;

            this.setState({
                report_data: data.length,
                all_data: true,
                restingHeartRate_data: restingHeartRate_data,
                systolicBloodPressure_data: systolicBloodPressure_data,
                diastolicBloodPressure_data: diastolicBloodPressure_data,
                heartRateVariabilityScore_data: heartRateVariabilityScore_data,
                hdl_data: hdl_data,
                ldl_data: ldl_data,
                totalCholesterol_data: totalCholesterol_data,
                totalCholesterolRatio_data: totalCholesterolRatio_data,
                max_y_val: max_y_val,
                min_y_val: 0 // reset min y val
            })
        } else {
            //this.msgDataLoaded();
        }
    }

    onMouseLeavePreWorkout = () =>{
        this.setState({crosshairPreValues: []});
    }

    ////   Tooltip Hover   ////
    onNearestXPreWorkout = (value, {index}) => {
        var x   = restingHeartRate_data[index].y;
        var x2  = restingHeartRate_data[index].x;
        var y1  = systolicBloodPressure_data[index].y;
        var y2  = diastolicBloodPressure_data[index].y;
        var y4  = heartRateVariabilityScore_data[index].y;
        var y5  = hdl_data[index].y;
        var y6  = ldl_data[index].y;
        var y7  = totalCholesterol_data[index].y;
        var y8  = totalCholesterolRatio_data[index].y;

        this.setState({
                        crosshairPreValues: [{x: x2, y: y1}],
                        crossHairX:  x,
                        crossHairY1: y1,
                        crossHairY2: y2,
                        crossHairY4: y4,
                        crossHairY5: y5,
                        crossHairY6: y6,
                        crossHairY7: y7,
                        crossHairY8: y8
                      });
    };

    getMaxYAxisVals (data) {
        var arr = []
        var data2 = eval(data); // get actual vals of array

        for(var key in data2)
            arr.push(data2[key].y);

        var max_y_val = Math.max(...arr) + 15;
        var min_y_val = Math.min(...arr) - 15;

        // Don't let min_y_val go below 0
        if(min_y_val < 0) min_y_val = 0;

        //console.log("max_y_val: " + max_y_val);
        //console.log("min_y_val: " + min_y_val);
        var maxMinObj = {};
        maxMinObj.max_y_val = max_y_val;
        maxMinObj.min_y_val = min_y_val;

        return maxMinObj;
    }

    handleLegendClick = item => {
        var data = item.data;
        var dataset;

        if(data === "all_data")
            this.setState({
                all_data: false
            }, () => {
                this.getClientData();
            });
        else {
            if(data === "restingHeartRate_data")                dataset = {"restingHeartRate_data":restingHeartRate_data, yAxisLabel: "Beats Per Minute"};
            else if(data === "systolicBloodPressure_data")      dataset = {"systolicBloodPressure_data":systolicBloodPressure_data, yAxisLabel: "mm HG"};
            else if(data === "diastolicBloodPressure_data")     dataset = {"diastolicBloodPressure_data":diastolicBloodPressure_data, yAxisLabel: "mm HG"};
            else if(data === "heartRateVariabilityScore_data")  dataset = {"heartRateVariabilityScore_data": heartRateVariabilityScore_data, yAxisLabel: "Score"};
            else if(data === "hdl_data")                        dataset = {"hdl_data": hdl_data, yAxisLabel: "mg/dl"};
            else if(data === "ldl_data")                        dataset = {"ldl_data": ldl_data, yAxisLabel: "mg/dl"};
            else if(data === "totalCholesterol_data")           dataset = {"totalCholesterol_data": totalCholesterol_data, yAxisLabel: "Ratio Score"};
            else if(data === "totalCholesterolRatio_data")      dataset = {"totalCholesterolRatio_data": totalCholesterolRatio_data, yAxisLabel: ""};

            var maxMinObj = this.getMaxYAxisVals(data);
            var max_y_val = maxMinObj.max_y_val;
            var min_y_val = maxMinObj.min_y_val;

            // Clear out all data since we're fiultering out datasets
            this.setState({
                all_data: false,
                current_dataset: data,
                restingHeartRate_data: [],
                systolicBloodPressure_data: [],
                diastolicBloodPressure_data: [],
                heartRateVariabilityScore_data: [],
                hdl_data: [],
                ldl_data: [],
                totalCholesterol_data: [],
                totalCholesterolRatio_data: [],
                max_y_val: max_y_val,
                min_y_val: min_y_val
            }, function (){
                this.setState(dataset);
            })
        }

        //const {items} = this.state;
        //item.disabled = !item.disabled;
    };

    getAllTooltip () {
        return <span>
                    <span style={{display:"inline-block", verticalAlign:"top", width: "57%"}}>
                        <span style={{display: "block",fontSize:16}}>{ legend1_title }: {this.state.crossHairX} bpm</span>
                        <span style={{display: "block",fontSize:16}}>{ legend2_title }: {this.state.crossHairY1} mm HG</span>
                        <span style={{display: "block",fontSize:16}}>{ legend3_title }: {this.state.crossHairY2} mm HG</span>
                        <span style={{display: "block",fontSize:16}}>{ legend5_title }: {this.state.crossHairY4} score</span>
                    </span>
                    <span style={{display:"inline-block", width: "43%"}}>
                        <span style={{display: "block",fontSize:16}}>{ legend6_title }: {this.state.crossHairY5} mg/dL</span>
                        <span style={{display: "block",fontSize:16}}>{ legend7_title }: {this.state.crossHairY6} mg/dL</span>
                        <span style={{display: "block",fontSize:16}}>{ legend8_title }: {this.state.crossHairY7} mg/dL</span>
                        <span style={{display: "block",fontSize:16}}>{ legend9_title }: {this.state.crossHairY8} </span>
                    </span>
                </span>
    }

    // Show only 1 value in the tooltip hover //
    getSingleTooltip () {
        var dataset = this.state.current_dataset;
        var legend;
        var value;
        var measure;
        if(dataset == "restingHeartRate_data") {
            legend    = legend1_title;
            value     = this.state.crossHairX;
            measure   = "bpm";
        } else if(dataset == "systolicBloodPressure_data") {
            legend    = legend2_title;
            value     = this.state.crossHairY1;
            measure   = "mm HG";
        } else if(dataset == "diastolicBloodPressure_data") {
            legend    = legend3_title;
            value     = this.state.crossHairY2;
            measure   = "mm HG";
        } else if(dataset == "heartRateVariabilityScore_data") {
            legend    = legend5_title;
            value     = this.state.crossHairY4;
            measure   = "score";
        } else if(dataset == "hdl_data") {
            legend    = legend6_title;
            value     = this.state.crossHairY5;
            measure   = "mg/dl";
        } else if(dataset == "ldl_data") {
            legend    = legend7_title;
            value     = this.state.crossHairY6;
            measure   = "mg/dl";
        } else if(dataset == "totalCholesterol_data") {
            legend    = legend8_title;
            value     = this.state.crossHairY7;
            measure   = "mg/dl";
        } else if(dataset == "totalCholesterolRatio_data") {
            legend    = legend9_title;
            value     = this.state.crossHairY8;
        }

        return <span>
                    <span style={{display:"inline-block", verticalAlign:"top", width: "100%"}}>
                        <span style={{display: "block",fontSize:16}}>{ legend }: { value } { measure }</span>
                    </span>
                </span>
    }

    render() {
        var title     = this.state.title;
        var max_y_val = this.state.max_y_val;
        var min_y_val = this.state.min_y_val;
        var all_data  = this.state.all_data;
        var report_data  = this.state.report_data;
        var no_data_text;
        if(report_data === 0)  no_data_text  = <div style={{position:"relative", top: 75, padding: 15, fontSize:18}}>There is no assessment data.</div>

        var tooltip;
        var tooltip_width = 300;
        if(all_data) {
            tooltip_width = 540;
            tooltip       = this.getAllTooltip();
        } else {
            tooltip       = this.getSingleTooltip();
        }

        return (
            <div className="assessmentForm" style={{textAlign:"left"}}>
                <div className="iconAddExercise35pxVertSpacer"></div>
                <span style={{position:"relative", left:-10}}>
                        <div style={{fontSize:22, textAlign:"center"}}>
                            <FontAwesomeIcon icon="dumbbell" style={{fontSize: '1.4em', paddingRight: 8 }}/>
                            <span style={{position:"relative", top:-4}}>
                                { title }
                                { no_data_text }
                            </span>
                        </div>
                        <span style={{display:"inline-block",width:"100%", border:"0px solid #000"}}>

                                <FlexibleWidthXYPlot height       = {200}
                                                     xType        = "ordinal"
                                                     yDomain      = {[min_y_val, max_y_val]}
                                                     onMouseLeave = {this.onMouseLeavePreWorkout}
                                                     onMouseDown  = {() => {
                                                         //this.setState({showModalProgressDetail: true})
                                                        /*if (heldValue) {
                                                          this.setState({heldValue: false});
                                                          return;
                                                        }*/
                                                        //this.setState({heldValue: crosshairValues});
                                                      }}
                                                     >
                                  <VerticalGridLines />
                                  <HorizontalGridLines />

                                  <XAxis title="" {...axisProps}
                                         tickFormat={String}/>

                                  <YAxis title={this.state.yAxisLabel}
                                         {...axisProps}
                                         //tickValues={[0,10,20,30,40,50,260]}
                                         tickFormat={String} />

                                  <LineMarkSeries data={this.state.restingHeartRate_data}           size={2.5} color={restingHeartRate_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.systolicBloodPressure_data}          size={2.5} color={systolicBloodPressure_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.diastolicBloodPressure_data}        size={2.5} color={diastolicBloodPressure_color} onNearestX={this.onNearestXPreWorkout}/>

                                  <LineMarkSeries data={this.state.heartRateVariabilityScore_data}        size={2.5} color={heartRateVariabilityScore_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.hdl_data}      size={2.5} color={hdl_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.ldl_data}              size={2.5} color={ldl_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.totalCholesterol_data}     size={2.5} color={totalCholesterol_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.totalCholesterolRatio_data}             size={2.5} color={totalCholesterolRatio_color} onNearestX={this.onNearestXPreWorkout}/>

                                  <Crosshair values={this.state.crosshairPreValues} >
                                      <div style={{float: "left", background: 'black', borderRadius: 5, width: tooltip_width, maxWidth: tooltip_width, borderRadius:5, padding: 10, zIndex: 1000}}>
                                          <span style={{display:"inline-block", width:"100%", fontSize:18, textAlign:"center"}}>{ title }</span>
                                             <br/>
                                             { tooltip }
                                      </div>
                                  </Crosshair>

                                </FlexibleWidthXYPlot>
                                { /**********  LEGEND  ***********/ }
                                <div style={{float: "left",  zIndex: 10}}>
                                    <DiscreteColorLegend items={STRENGTH_LEGEND}
                                                         orientation='horizontal'
                                                         onItemClick={this.handleLegendClick}
                                                         style={{display: "inline-block", position:"relative", width:900, top:-7, left:35}}/>
                                </div>
                        </span>
                 </span>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/report/AssessHeartAndBlood.js